module.exports = __webpack_public_path__ + "static/img/bg_shouye.b0a66774.jpg";